import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import MetadataData from './Data';
import View from './View';

const metadataEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      Metadata Block
      <View {...props} />
      <SidebarPortal selected={selected}>
        <MetadataData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(metadataEdit);
